/**
 * The server-side "Accept all" reads (2026-10-19): a book's running jobs (`status` is only ever `active`) and
 * one job's progress. The job's cancel is a POST in `bookkeeping-writes.ts`, so nothing below the id is
 * declared. The id is the API's own `raj_` token, so a word like `active` never rides the detail entry.
 * Split out of `catalog.ts` on file-size grounds only.
 *
 * Also Review's AI suggestions view (owner, 2026-10-20): every pending line the AI suggested in one book,
 * oldest first, a static segment under `review/` beside the job reads.
 */
import type { ReadRoute } from "./catalog";

export const ACCEPT_JOB_READ_ROUTES: readonly ReadRoute[] = [
  {
    path: "/api/admin/bookkeeping/books/:bookId/review/suggestions",
    query: ["cursor", "limit"],
  },
  {
    path: "/api/admin/bookkeeping/books/:bookId/review/accept-jobs",
    query: ["status"],
  },
  {
    path: "/api/admin/bookkeeping/books/:bookId/review/accept-jobs/:jobId{raj_[0-9a-f-]+}",
    query: [],
  },
];
